module.exports = __webpack_public_path__ + "static/img/experian_ico.455c2a35.png";